import { render, staticRenderFns } from "./PrepworldFaq.vue?vue&type=template&id=3013ccfc&"
import script from "./PrepworldFaq.vue?vue&type=script&lang=js&"
export * from "./PrepworldFaq.vue?vue&type=script&lang=js&"
import style0 from "./PrepworldFaq.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports